import * as Styled from './Footer.style';

const Footer = () => {
  return (
    <Styled.Wrapper>
      <Styled.NameText>Victor</Styled.NameText>
      <Styled.CopyRightText>© Victor. All Rights Reserved.</Styled.CopyRightText>
    </Styled.Wrapper>
  );
};

export default Footer;
